module.exports = __webpack_public_path__ + "img/grid-3.f92aa08c.svg";